import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CreateShareListModalComponent} from "./create-share-list-modal.component";
import {SharedModule} from "../../../shared.module";
import { FormsModule } from '@angular/forms';
import {ModalModule} from "ngx-bootstrap/modal";


@NgModule({
    declarations: [
        CreateShareListModalComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ModalModule
    ]
})
export class CreateShareListModalModule { }
